export const SCRIPT_EDITOR = 'SCRIPT_EDITOR';
export const HTML_POPUP_EDITOR = 'HTML_POPUP_EDITOR';
export const CSS_POPUP_EDITOR = 'CSS_POPUP_EDITOR';
export const PARAMS_POPUP_EDITOR = 'PARAMS_POPUP_EDITOR';